import { COMPONENT_STATES, COMPONENT_TYPE as TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import View, { SHAPE_TYPE } from 'client/components/common/BuildingBlocks/Shape/Shape';
import { generateElementId, generateNodeId } from 'client/components/common/BuildingBlocks/utils/common';

export const SHAPE = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.SHAPE,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: SHAPE.displayName,
					selectable: true,
					draggable: true,
					expandable: false,
					expanded: false,
				},

				componentProps: {
					other: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								shapeType: SHAPE_TYPE.RECT,
							},
						},
					},
					styles: {
						[COMPONENT_STATES.DEFAULT]: {
							[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
								// ...
							},
						},
					},
				},
				nodeProps: {
					id: generateNodeId(_id, SHAPE.displayName),
				},
			},
			children: [],
		},
	};
};

SHAPE.displayName = 'Shape';
